import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IResponse } from '../../programs/Models/response.model';
import { HttpCallService } from '../services/base.service';
import { AppConstant } from '../../app.constants';
import { tap } from 'rxjs/operators';

@Injectable()
export class CommonServiceHelper {

    constructor(private _dataService: HttpCallService,
        private _appConstant: AppConstant) { }

    getProgramCountry(data?: string): Observable<IResponse> {
        const apiURL = this._appConstant.APIUrl + 'LookUp/GetCountries';
        return this._dataService.get<IResponse>(apiURL);
    };

    getProgramCountries(data?: string): Observable<IResponse> {
        const apiURL = this._appConstant.APIUrl + 'LookUp/GetProgramCountries/' + this._appConstant.programId;
        return this._dataService.get<IResponse>(apiURL);
    };    

    getAdminSiteUrls(data?: string): Observable<IResponse> {
        const apiURL = this._appConstant.APIUrl + 'User/GetAdminSiteUrls';
        return this._dataService.get<IResponse>(apiURL);
    };

    getProgramType(data?: string): Observable<IResponse> {
        const apiURL = this._appConstant.APIUrl + 'LookUp/GetProgramTypes';
        return this._dataService.get<IResponse>(apiURL);
    };

    getProgramDataSource(data?: string): Observable<IResponse> {
        const apiURL = this._appConstant.APIUrl + 'LookUp/GetPrograms';
        return this._dataService.get<IResponse>(apiURL);
    };

    getProductType(): Observable<any> {
        const apiURL = this._appConstant.APIUrl + 'LookUp/GetProductTypes';
        return this._dataService.get<any>(apiURL);
    };

    getProductCategory(): Observable<any> {
        const apiURL = this._appConstant.APIUrl + 'LookUp/GetProductCategories';
        return this._dataService.get<any>(apiURL);
    };

    getConcentrationUnits(): Observable<any> {
        const apiURL = this._appConstant.APIUrl + 'LookUp/GetConcentrationUnits';
        return this._dataService.get<any>(apiURL);
    };

    getDosingLevelUnits(): Observable<any> {
        const apiURL = this._appConstant.APIUrl + 'LookUp/GetDosingLevels';
        return this._dataService.get<any>(apiURL);
    };

    getLanguageList(data?: string): Observable<IResponse> {
        const apiURL = this._appConstant.APIUrl + 'LookUp/GetLanguages';
        return this._dataService.get<IResponse>(apiURL);
    };

    getRoleList(data?: any): Observable<any> {
        const apiURL = this._appConstant.APIUrl + 'RolePermissions/GetAllRoles';
        return this._dataService.get<any>(apiURL);
    };

    searchKeyWord(search: any): Observable<IResponse> {
        const apiURL = this._appConstant.APIUrl + 'Location/GetLocationSearch';
        return this._dataService.post<IResponse>(apiURL, search)
            .pipe(tap((response: IResponse) => {
                response.data = response.data.map(user => user);
                return response;
            })
            );
    }

    GetToken(): Observable<any> {
        const apiURL = this._appConstant.APIUrl + 'user/GetToken';
        return this._dataService.get<any>(apiURL);
    }

    getAdminDashboardReport(): Observable<IResponse> {
        const apiURL = this._appConstant.APIUrl + 'User/GetAdminReportUrl';
        return this._dataService.get<IResponse>(apiURL);
    };

    getUserDashboardReport(): Observable<IResponse> {
        const apiURL = this._appConstant.APIUrl + 'Program/GetProgramReportUrl/' + this._appConstant.programId;
        return this._dataService.get<IResponse>(apiURL);
    };

    getLocationData(): Observable<IResponse> {
        const apiURL = this._appConstant.APIUrl + 'Location/GetLocations';
        return this._dataService.get<IResponse>(apiURL);
    } 
}
